export class AssetServiceReq {
  plant?:number;
   assetId?: number;
   location?:number;
   assetCode?:string;
   plantId?:number;
 assetType?: string;
 assetCategory?: string;
 startDate?:any;
 endDate?:any;
 constructor(plant?:number, assetId?: number,
   
   location?:number,
   assetCode?:string,
   plantId?:number,
 assetType?: string,
 assetCategory?: string,
 startDate?:any,
 endDate?:any,){
  
  this.plant = plant
  this.assetId =assetId
  this.location =location
  this.assetCode =assetCode
  this.plantId =plantId
  this.assetType =assetType
  this.assetCategory =assetCategory
  this.startDate=startDate
  this.endDate= endDate           
}
}